import React from "react";
import { useCurrentProfile } from "@domain/currentProfile/hooks";
import { Group } from "@domain/group/group";
import { useModalTools } from "@ui/modals/modalContext";
import { KebabMenu } from "@ui/components/menus/kebabMenu";
import { SimpleMenuContent } from "@ui/components/menus/simpleMenuContent";
import { EditReferencePostModal } from "@ui/components/post/reference/editReferencePostModal";

interface ShareroomThumbnailMenuProps extends React.HTMLAttributes<HTMLDivElement> {
	shareroom: Group;
}

export const ShareroomThumbnailMenu: React.FC<ShareroomThumbnailMenuProps> = ({ shareroom, ...htmlProps }) => {
	const currentProfile = useCurrentProfile();
	const { createModal } = useModalTools();
	const isAuthor = shareroom.owner.id === currentProfile?.id;
	return (
		<KebabMenu {...htmlProps}>
			<SimpleMenuContent
				onShare={() =>
					createModal((close) => (
						<EditReferencePostModal close={close} shared={{ type: "SHARE_GROUP", reference: shareroom }} />
					))
				}
				reportInfos={
					isAuthor
						? undefined
						: {
								contentId: shareroom.id,
								contentType: "GROUP",
							}
				}
			/>
		</KebabMenu>
	);
};
